import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FormSelect from "./FormSelect";

import {COSTS} from '../../utilities/constants';
import {TEXT} from '../../utilities/strings';

/**
 * Component to render the Cost Select dropdown
 *
 * @example
 * return (
 *  <CostSelect
 *    label={Text to display}
 *    formId=ID of form element
 *    formName={this.props.formName}
 *    value={this.state.selectedCost}
 *    onChange={value => this.setState({selectedCost: value})}
 *  />
 *  )
 */
export default class CostSelect extends Component {

  static propTypes = {
    value: PropTypes.string,
    formId: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  };

  render() {
    return (
      <FormSelect
        value={this.props.value}
        label={this.props.label}
        formId={this.props.formId}
        formName={this.props.formName}
        onChange={this.props.onChange}
      >
        <option value={COSTS.TOTAL}>{TEXT.cost_total}</option>
        <option value={COSTS.FATAL}>{TEXT.cost_fatal}</option>
        <option value={COSTS.NONFATAL}>{TEXT.cost_nonfatal}</option>
      </FormSelect>
    );
  }
}
